import Api from '@/services/Api'

export default {
    get(discountId) {
      return Api().get(`discounts/${discountId}/discount-details`).then(function (response) {
        return (response)
      })
    },
    add(discountId, data) {
      return Api().post(`discounts/${discountId}/discount-details`, data).then(function (response) {
        return (response)
      })
    },
    getById(id) {
      return Api().get(`discount-details/${id}`).then(function (response) {
        return (response)
      })
    },
    partialUpdate(id, data) {
      return Api().patch(`discount-details/${id}`, data).then(function (response) {
        return (response)
      })
    }
}